module.exports = __webpack_public_path__ + "img/result-detail-communication-title.c9602315.svg";